export const blockIconsCommunicationChatBubbleOutline = (
	<span className='material-symbols-outlined'>chat_bubble_outline</span>
);
